var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('GraphCreate')],1),_c('b-col',[_c('GraphList')],1)],1),_c('UrlChoose'),_c('GraphPlay'),_c('NetworkView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }